export function isAuthDomain() {
    return window.location.hostname.split('.')[0] === 'auth';
}
